/**
 * Expose all endponts for 'reference'.
 */
export const referenceDataApiMock = api => ({
  clusters: () =>
    Promise.resolve({
      data: [
        { id: 1, name: "Cluster 1", description: "Cluster 1" },
        { id: 2, name: "Cluster 2", description: "Cluster 2" },
        { id: 3, name: "Cluster 3", description: "Cluster 3" }
      ],

      ok: true
    }),
  profileBrands: () =>
    Promise.resolve({
      data: [
        {
          code: "other",
          name: "Costa Line"
        },
        {
          code: "iamsa",
          name: "ETN"
        }
      ],

      ok: true
    }),
  logicalLocations: () =>
    Promise.resolve({
      data: [
        {
          id: 1,
          name: "Argentina",
          description: "Argentina",
          children: [
            { id: 3, name: "Buenos Aires", description: "Buenos Aires" },
            {
              id: 4,
              name: "Córdoba",
              description: "Córdoba",
              children: [
                { id: 6, name: "Villa María", description: "Villa María" }
              ]
            }
          ]
        },

        {
          id: 2,
          name: "Brasil",
          description: "Brasil",
          children: [{ id: 5, name: "San Pablo", description: "San Pablo" }]
        }
      ],

      ok: true
    }),
  geoLocations: () =>
    Promise.resolve({
      data: [
        {
          id: 951,
          name: "ARGENTINA",
          description: "Argentina",
          children: [
            {
              id: 953,
              name: "BUENOS AIRES",
              description: "Buenos Aires",
              children: [],
              parentId: 951
            },
            {
              id: 954,
              name: "CORDOBA",
              description: "Cordoba",
              children: [],
              parentId: 951
            },
            {
              id: 955,
              name: "MENDOZA",
              description: "Mendoza",
              children: [],
              parentId: 951
            }
          ],
          parentId: null
        },
        {
          id: 952,
          name: "BRASIL",
          description: "Brasil",
          children: [
            {
              id: 956,
              name: "BAHIA",
              description: "Bahia",
              children: [],
              parentId: 952
            },
            {
              id: 957,
              name: "RIO DE JANEIRO",
              description: "Rio de Janeiro",
              children: [],
              parentId: 952
            },
            {
              id: 958,
              name: "SAN PABLO",
              description: "San Pablo",
              children: [],
              parentId: 952
            }
          ],
          parentId: null
        }
      ],

      ok: true
    })
});

export const referenceDataApi = api => ({
  clusters: () => api.get("clusters"),

  logicalLocations: () => api.get("logical-locations"),

  geoLocations: () => api.get("geo-locations"),

  criticalMoments: () => api.get("critical-moments"),

  profileBrands: () =>
    Promise.resolve({
      data: [
        {
          code: "other",
          name: "Costa Line"
        },
        {
          code: "iamsa",
          name: "ETN"
        }
      ],

      ok: true
    })
});



// WEBPACK FOOTER //
// ./src/services/api/ReferenceDataApi.js